
document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.includes("pages/trade-program")) {
        let a = document.querySelectorAll('.pxs-image-with-text-wrapper .pxs-image-with-text-button');
        console.log(a);
        if (a.length) {
            a.forEach(element => {
                element.href = 'http://dtystore.com/pages/trade-program-form';
            });
        }
    }
});
